import {useGrpcRequest} from '@aboutyou/data-fetcher';
import {StoryPageService_GetFiltersLazy} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/story_page/v1/service.grpc.lazy';
import {useFullSession} from '@aboutyou/user';
import {useCategoryIdentifier} from '../../../features/hooks/useCategoryIdentifier';
import {labelToSortingOption} from '../../../features/ProductStream/helpers';
import {
  useAppliedLiveAtFilter,
  useAppliedPotentialFilters,
  useSorting,
} from '../../../features/ProductStream/utils';
import {useReductionsStateRequestParameter} from '../../../features/ReductionsState/useReductionsStateRequestParameter';
import {useTargetGroupIdentifier} from '../../../shared-deprecated/useTargetGroupIdentifier';
import {useStoryIdFromUrl} from './useStoryIdFromUrl';

export const useStoryFilters = () => {
  const storyId = useStoryIdFromUrl();
  const appliedFilters = useAppliedPotentialFilters();
  const categoryIdentifier = useCategoryIdentifier();
  const liveAtFilter = useAppliedLiveAtFilter();
  const targetGroupIdentifier = useTargetGroupIdentifier();
  const {sorting} = useSorting();
  const fullSession = useFullSession();
  const reductionsState = useReductionsStateRequestParameter();

  return useGrpcRequest(
    StoryPageService_GetFiltersLazy,
    {
      session: fullSession ?? null,
      storyId: storyId!,
      targetGroup: targetGroupIdentifier,
      categoryId: categoryIdentifier?.identifier.id ?? null,
      appliedFilters: {
        filters: appliedFilters,
        liveAt: liveAtFilter
          ? {
              minDate: liveAtFilter,
            }
          : undefined,
      },
      sortOptions: labelToSortingOption(sorting),
      reductionsState,
    },
    {
      disabled: !storyId,
      keepPreviousData: true,
      mockData: async () =>
        import('./__mocks__/getStoryFiltersMock').then(module =>
          module.getStoryFiltersMock(),
        ),
    },
  );
};
